import React, { Component } from "react";
import {
  Form,
  Select,
  Input,
  message,
  Table,
  Button,
  Row,
  Col,
  Spin,
  InputNumber,
  Popconfirm,
  Modal,
  Card,
  Alert,
  Tabs,
  Space,
  Tooltip,
  Image
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import SensorMappingStore from "../store/SensorMappingStore";
import withRouter from "../withRouter";
import CompanyAutocomplete from "./CompanyAutocomplete";
import CompanyStore from "../store/CompanyStore";
import { DeleteFilled } from "@ant-design/icons";
import VehicleStore from "../store/VehicleStore";
import { Link } from "react-router-dom";
import config from "../config";

const { Column } = Table;
const { Option } = Select;
const { TabPane } = Tabs;

class SensorMappingAdd extends Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      formError: false,
      activeTab: "1",
      tabErrors: {},
      loading: false,
      companyId: "",
      loadingSpin: false,
      sensor_data: [],
      sensor_mapping: [],
      selectedSensorId: undefined,
      selectedMappingId: undefined,
      tableData: [],
      fuelTableData: [],
      weightTableData: [],
      multiplier: 1,
      editKey: null,
      showFuelCalibration: false,
      showWeightCalibration: false,
      fuelSensor: null,
      weightSensor: null,
      listTblCount: 1,
      listWeightTblCount: 1,

      volumePerUnit: 0,
      minVoltage: 0,
      maxVoltage: 0,
      fuelTankCapacity: 0,

      volumePerUnitWeight: 0,
      minVoltageWeight: 0,
      maxVoltageWeight: 0,
      maxWeight: 0,

    };

    this.sensorMappingStore = new SensorMappingStore();
    this.companyStore = new CompanyStore();
    this.vehicleStore = new VehicleStore();

  }
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {

      this.context.viewStateStore.setVehicleGroupStates({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
        isadmin: this.props.getUserData().isadmin,
      });
     
    }

    const sensorMappingId = this.props.sensorMappingId;

    if (sensorMappingId) {
      await this.filldata(sensorMappingId);
      await this.setState({ sensorMappingId });
    }

    await this.vehicleStore.getDevices({"sensorMapping": true});

    await this.setState({ loadList: 1 });
    
  }

  handleAddFuelRecord = () => {
    const { fuelTableData } = this.state;
    this.setState({ listTblCount: this.state.listTblCount + 1 });
    this.setState({
      fuelTableData: [
        ...fuelTableData,
        {
          rId: this.state.listTblCount,
          fuel: 0,
          voltage: 0,
          Id: 0,
          fuelCalibrationName: "",
          fuelTankCapacity: "",
          maxVoltage: "",
          minVoltage: "",
        },
      ],
    });
  };

  handleAddWeightRecord = () => {
    const { weightTableData } = this.state;
    this.setState({ listWeightTblCount: this.state.listWeightTblCount + 1 });
    this.setState({
      weightTableData: [
        ...weightTableData,
        {
          weight_rId: this.state.listWeightTblCount,
          weight: 0,
          weight_voltage: 0,
          Id: 0,
          weightCalibrationName: "",
          maxWeight: "",
          maxVoltageWeight: "",
          minVoltageWeight: "",
        },
      ],
    });
  };

  handleInputChange = (e, index, fieldName) => {
    const newData = [...this.state.fuelTableData];
    newData[index][fieldName] = e.target.value;
    this.setState({ fuelTableData: newData });
  };

  handleWeightInputChange = (e, index, fieldName) => {
    const newData = [...this.state.weightTableData];
    newData[index][fieldName] = e.target.value;
    this.setState({ weightTableData: newData });
  };

  // async onDeleteGridData(record) {

  //   const response = await this.vehicleFuelStore.deleteGridData({
  //     Id: record.Id,
  //     fuelCalibrationId: record.fuelCalibrationId,
  //   });

  //   if (response?.data?.success === "S") {
  //     message.success(response.data.message);
  //   }
  // }

  onDeleteRow = (index) => {
    const filterData = this.state.fuelTableData.filter((val, ind) => ind !== index);
    // console.log(filterData);
    this.setState({ fuelTableData: filterData });
  };

  onWeightDeleteRow = (index) => {
    const filterData = this.state.weightTableData.filter((val, ind) => ind !== index);
    // console.log(filterData);
    this.setState({ weightTableData: filterData });
  };

  checkSensorCalibration = (tableData) => {
    const fuelSensor = tableData.find((item) => {
      // console.log("item",item)
      const name = item.mappingName?.toLowerCase();

      return ( item.sensorId == 239 &&
        (name === "fuel level 1" ||
        name === "fuel level 2")
      );
    });

    const weightSensor = tableData.find((item) => {
      const name = item.mappingName?.toLowerCase();

      return (
        item.sensorId == 239 && name === "weight"
      );
    });

    this.setState({
      showFuelCalibration: !!fuelSensor,
      fuelSensor,

      showWeightCalibration: !!weightSensor,
      weightSensor,
    });
  };

  showTabTitle = () => {
    const { activeTab } = this.state;

    if (activeTab === "1") {
      return this.context.translate("_SENSOR_MAPPING_");
    } else if (activeTab === "2") {
      return this.context.translate("_FUEL_CALIBRATION_");
    } else if (activeTab === "3") {
      return this.context.translate("_WEIGHT_CALIBRATION_");
    }
  };

  showTabDesc = () => {
    const { activeTab } = this.state;
    if (activeTab === "1") {
      return this.context.translate("_SENSOR_MAPPING_ADD_FORM_DESC_");
    } else if (activeTab === "2") {
      return this.context.translate("_VEHICLE_FUEL_CALIBRATION_ADD_DESC_");
    } else if (activeTab === "3") {
      return this.context.translate("_VEHICLE_WEIGHT_CALIBRATION_ADD_DESC_");
    }
  };

  handleTabChange = (key) => {
    this.setState({
      activeTab: key,
      formError: false,
    });
  };

  closeSensorMappingForm = () => {
    this.props.closeModal();
  };

  closeModal = () => {
    this.props.closeModal();
  };

  getVisibleTabs = () => {
    const tabs = ["1"];

    if (this.state.showFuelCalibration) {
      tabs.push("2");
    }

    if (this.state.showWeightCalibration) {
      tabs.push("3");
    }

    return tabs;
  };

  handleBackClick = () => {
    const tabs = this.getVisibleTabs();
    const currentIndex = tabs.indexOf(this.state.activeTab);

    if (currentIndex > 0) {
      this.setState({
        activeTab: tabs[currentIndex - 1],
      });
    } else {
      this.closeModal();
    }
  };

  handleNextClick = async () => {

    const form = this.formRef.current;

    if (!form) return;

    try {
      if (this.state.activeTab === "1") {
        await form.validateFields([
          "companyId",
          "deviceId",
          "templateName",
        ]);
      }else if (this.state.activeTab === "2") {
        await form.validateFields([
          "fuelCalibrationName",
          "fuelTankCapacity",
          "maxVoltage",
          "minVoltage"
        ]);
      } else {
        await form.validateFields();
      }

      const tabs = this.getVisibleTabs();
      const currentIndex = tabs.indexOf(this.state.activeTab);

      if (currentIndex < tabs.length - 1) {
          this.setState({
              activeTab: tabs[currentIndex + 1],
          });
      }

    } catch (err) {
      console.error("Form Validation Error:", err);

      message.error(
        this.context.translate("_FLEET_VEHICLE_VEHICLEDETAIL_ERRORMSG_")
      );

      this.setState({ formError: true });
    }
  };

  handleFormError = (err) => {

    const { errorFields } = err;

    const tabErrors = {};

    const tabFieldMappings = {
      companyId: 1,
      deviceId: 1,
      templateName: 1,
      fuelCalibrationName: 2,
      fuelTankCapacity: 2,
      maxVoltage: 2,
      minVoltage: 2,
      weightCalibrationName: 3,
      maxWeight: 3,
      maxVoltageWeight: 3,
      minVoltageWeight: 3,
    };

    errorFields.forEach(({ name }) => {
      
      const [fieldName] = name;
      const tab = tabFieldMappings[fieldName];

      if (tab && String(tab) !== this.state.activeTab) {
        tabErrors[tab] = true;
      }
    });

    this.setState({ tabErrors });

  };

  isLastTab = () => {

    const tabs = this.getVisibleTabs();
    return this.state.activeTab === tabs[tabs.length - 1];
  };

  editRecord = (record) => {

    this.setState({
        editKey: record.key,
        selectedSensorId: record.sensorId,
        selectedMappingId: record.mappingId,
        multiplier: record.multiplier,
    });

    this.formRef.current.setFieldsValue({
        sensorId: record.sensorId,
        sensorType: record.mappingId,
        multiplier: record.multiplier,
    });
  };

  async handleDeviceFields(val) {
    if (this.state.tableData.length > 0) {
      Modal.confirm({
        title: "Change Device?",
        content:
          "Changing the device will remove all sensor mappings added to the table. Do you want to continue?",
        okText: "Yes",
        cancelText: "No",

        onOk: async () => {
          
          this.setState({
            tableData: [],
            showFuelCalibration: false,
            showWeightCalibration: false,
            weightTableData: [],
            fuelTableData: [],
            selectedDeviceId: val,
            sensor_data: [],
            sensor_mapping: [],
          }, () => {
            this.resetSensorForm();
          });

          const postData = {
            deviceId: val,
          };

          const { sensor_data, sensor_mapping } =
            await this.sensorMappingStore.sensorCodecData(postData);

          this.setState({ sensor_data, sensor_mapping });
        },

        onCancel: () => {
          this.formRef.current.setFieldsValue({
            deviceId: this.state.selectedDeviceId,
          });
        },
      });
    } else {
      this.setState({
        selectedDeviceId: val,
      });

      const postData = {
        deviceId: val,
      };

      const { sensor_data, sensor_mapping } =
        await this.sensorMappingStore.sensorCodecData(postData);

      this.setState({ sensor_data, sensor_mapping });
    }
  }

  resetSensorForm = () => {
      this.setState({
          editKey: null,
          selectedSensorId: undefined,
          selectedMappingId: undefined,
          multiplier: 1,
      });

      this.formRef.current.setFieldsValue({
          sensorId: undefined,
          sensorType: undefined,
          multiplier: 1,
      });
  };

  calculateVolumePerUnit = async () => {
    if (
      this.state.minVoltage != "" &&
      this.state.maxVoltage != "" &&
      this.state.fuelTankCapacity != ""
    ) {

      const minVoltage = parseFloat(this.state.minVoltage);
      const maxVoltage = parseFloat(this.state.maxVoltage);
      const fuelTankCapacity = parseFloat(this.state.fuelTankCapacity);

      const volumePerUnit = (
        fuelTankCapacity /
        (maxVoltage - minVoltage)
      ).toFixed(2);
      await this.setState({ volumePerUnit: volumePerUnit });
      this.formRef.current.setFieldsValue({ volumePerUnit: volumePerUnit });
    }
  };

  calculateWeightVolumePerUnit = async () => {
    if (
      this.state.minVoltageWeight != "" &&
      this.state.maxVoltageWeight != "" &&
      this.state.maxWeight != ""
    ) {

      const minVoltageWeight = parseFloat(this.state.minVoltageWeight);
      const maxVoltageWeight = parseFloat(this.state.maxVoltageWeight);
      const maxWeight = parseFloat(this.state.maxWeight);

      const volumePerUnitWeight = (
        maxWeight /
        (maxVoltageWeight - minVoltageWeight)
      ).toFixed(2);
      await this.setState({ volumePerUnitWeight: volumePerUnitWeight });
      this.formRef.current.setFieldsValue({ volumePerUnitWeight: volumePerUnitWeight });
    }
  };


  validateFieldsValue = (value, field) => {

    const value1 = value.replace(/[^0-9.,]+/g, "");

    if (value1.length > 0) {
      this.formRef.current.setFieldsValue({ [field]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field]: "" });
    }

    if (field == "minVoltage") {
      this.setState({ minVoltage: value1 });
    }
    if (field == "maxVoltage") {
      this.setState({ maxVoltage: value1 });
    }
    if (field == "fuelTankCapacity") {
      this.setState({ fuelTankCapacity: value1 });
    }

    
    if (field == "minVoltageWeight") {
      this.setState({ minVoltageWeight: value1 });
    }
    if (field == "maxVoltageWeight") {
      this.setState({ maxVoltageWeight: value1 });
    }
    if (field == "maxWeight") {
      this.setState({ maxWeight: value1 });
    }

  };

  

  handleAddRecord = () => {

    const {
      selectedSensorId,
      selectedMappingId,
      multiplier,
      tableData,
      sensor_data,
      sensor_mapping,
    } = this.state;

    if (!selectedSensorId || !selectedMappingId) {
      message.error("Please select Sensor ID and Sensor Type");
      return;
    }

    const sensor = sensor_data.find(
      (item) => item.id === selectedSensorId
    );

    const mapping = sensor_mapping.find(
      (item) => item.id === selectedMappingId
    );

    const exists = tableData.some(
      item => item.sensorId === selectedSensorId
    );

    if (exists) {
      message.error("Sensor already added");
      return;
    }

    const newRecord = {
      key: Date.now(),
      sensorId: selectedSensorId,
      sensorName: sensor?.name,
      mappingId: selectedMappingId,
      mappingName: mapping?.name,
      multiplier: multiplier || 1,
    };

    const updatedTable = [...tableData, newRecord];

    this.setState({
      tableData: updatedTable,
    }, () => {
      this.checkSensorCalibration(updatedTable);
      this.resetSensorForm();
    });

  };

  handleUpdateRecord = () => {
    
    const {
      editKey,
      selectedSensorId,
      selectedMappingId,
      multiplier,
      tableData,
      sensor_data,
      sensor_mapping,
    } = this.state;

    const exists = tableData.some(
      item =>
        item.sensorId === selectedSensorId &&
        item.key !== editKey
    );

    if (exists) {
      message.error("Sensor already added");
      return;
    }

    const updatedTable = tableData.map((item) => {
        if (item.key !== editKey) return item;

        return {
            ...item,
            sensorId: selectedSensorId,
            sensorName: sensor_data.find(s => s.id === selectedSensorId)?.name,
            mappingId: selectedMappingId,
            mappingName: sensor_mapping.find(m => m.id === selectedMappingId)?.name,
            multiplier,
        };
    });

    this.setState({
      tableData: updatedTable,
    }, () => {
      this.checkSensorCalibration(updatedTable);
      this.resetSensorForm();
    });

  };

  handleCancelEdit = () => {
    this.resetSensorForm();
  };

  filldata = async (sensorMappingId) => {

    await this.setState({ loadingSpin: true });

    const sensorMappingData = await this.sensorMappingStore.loadData({
      companyId: this.props.companyId,
      offset: 0,
      limit: 1,
      sensorMappingId: sensorMappingId
    });

    const deviceId = sensorMappingData.data[0].deviceId;

    const singleData = await this.companyStore.getCompanyDataById(
      this.props.companyId
    );

    await this.setState({
      companyId: sensorMappingData?.data?.companyId,
      sensorMappingId: sensorMappingData?.data[0]?.id,
      selectedDeviceId: sensorMappingData?.data[0]?.deviceId,
      showFuelCalibration: !!sensorMappingData.fuelCalibration,
      showWeightCalibration: !!sensorMappingData.weightCalibration,
      fuelTableData: sensorMappingData.fuelCalibrationDetails || [],
      weightTableData: sensorMappingData.weightCalibrationDetails || [],
    });

    await this.formRef.current.setFieldsValue({
      companyId: singleData,
      templateName: sensorMappingData?.data[0]?.templateName,
      deviceId: sensorMappingData?.data[0]?.deviceId,

      // Fuel
      fuelCalibrationName: sensorMappingData.fuelCalibration?.fuelCalibrationName,
      fuelTankCapacity: sensorMappingData.fuelCalibration?.fuelTankCapacity,
      maxVoltage: sensorMappingData.fuelCalibration?.maxVoltage,
      minVoltage: sensorMappingData.fuelCalibration?.minVoltage,
      volumePerUnit: sensorMappingData.fuelCalibration?.volumePerUnit,

      // Weight
      weightCalibrationName: sensorMappingData.weightCalibration?.weightCalibrationName,
      maxWeight: sensorMappingData.weightCalibration?.maxWeight,
      maxVoltageWeight: sensorMappingData.weightCalibration?.maxVoltage,
      minVoltageWeight: sensorMappingData.weightCalibration?.minVoltage,
      volumePerUnitWeight: sensorMappingData.weightCalibration?.volumePerUnit,
    });

    const { sensor_data, sensor_mapping } =
        await this.sensorMappingStore.sensorCodecData({ deviceId });
    
    await this.setState({sensor_data, sensor_mapping});    

    const tableData = sensorMappingData?.sensorMappings?.map((item, index) => {
      const sensor = this.state.sensor_data.find(
        (s) => s.id === item.sensorId
      );

      const mapping = this.state.sensor_mapping.find(
        (m) => m.id === item.mappingId
      );

      return {
        key: index,
        sensorId: item.sensorId,
        sensorName: sensor_data.find(s => s.id === item.sensorId)?.name,
        mappingId: item.mappingId,
        mappingName: sensor_mapping.find(m => m.id === item.mappingId)?.name,
        multiplier: item.multiplier,
      };
    }) || [];

    this.setState({
        tableData,
    }, () => {
        this.checkSensorCalibration(tableData);
    });

    this.setState({
      volumePerUnit: sensorMappingData.fuelCalibration?.volumePerUnit || 0,
      minVoltage: sensorMappingData.fuelCalibration?.minVoltage || 0,
      maxVoltage: sensorMappingData.fuelCalibration?.maxVoltage || 0,
      fuelTankCapacity: sensorMappingData.fuelCalibration?.fuelTankCapacity || 0,

      volumePerUnitWeight: sensorMappingData.weightCalibration?.volumePerUnit || 0,
      minVoltageWeight: sensorMappingData.weightCalibration?.minVoltage || 0,
      maxVoltageWeight: sensorMappingData.weightCalibration?.maxVoltage || 0,
      maxWeight: sensorMappingData.weightCalibration?.fuelTankCapacity || 0,
    });

    await this.setState({ loadingSpin: false });
    
  };

  onSensorMappingSubmit = async (values) => {

    if (!this.state.tableData.length) {
      message.error("Please add at least one sensor");
      return;
    }

    this.setState({ loading: true });

    const data = {
      templateId: this.state.sensorMappingId,
      companyId: this.state.companyId,
      deviceId: this.state.selectedDeviceId,
      templateName: values.templateName,
      createdBy: this.props.getUserData().userId,
      updatedBy: this.props.getUserData().userId,

      sensors: this.state.tableData.map(item => ({
        sensorId: item.sensorId,
        mappingId: item.mappingId,
        multiplier: item.multiplier,
      })),

      fuelCalibration: this.state.showFuelCalibration
        ? {
            fuelCalibrationName: values.fuelCalibrationName,
            fuelTankCapacity: values.fuelTankCapacity,
            volumePerUnit: values.volumePerUnit,
            maxVoltage: values.maxVoltage,
            minVoltage: values.minVoltage,
            records: this.state.fuelTableData,
          }
        : null,


      weightCalibration: this.state.showWeightCalibration
        ? {
            weightCalibrationName: values.weightCalibrationName,
            maxWeight: values.maxWeight,
            volumePerUnitWeight: values.volumePerUnitWeight,
            maxVoltageWeight: values.maxVoltageWeight,
            minVoltageWeight: values.minVoltageWeight,
            records: this.state.weightTableData,
          }
        : null,

    };

    // console.log("data",data)

    const resp = await this.sensorMappingStore.addData(data);

    await this.props.response(resp);

    this.setState({ loading: false });

  };

 
  handleChange = async (comp) => {
    await this.setState({ companyId: comp.value });
    if (!this.props.vehicleGroupId) {
      this.context.viewStateStore.setVehicleGroupStates({
        companyId: comp.value,
      });
    }
  };

  render() {

    return (
      <div style={{ padding: 0, height: "100%" }}>
        <div style={{ paddingBottom: "10px", height: "100%" }}>
          <Spin
            wrapperClassName="spinClass"
            spinning={this.state.loadingSpin}
            fullscreen
          >
            <Form
              style={{ maxWidth: "100%", padding: 0 }}
              layout="vertical"
              ref={this.formRef}
              onFinish={this.onSensorMappingSubmit}
              onFinishFailed={(value) => {
                // console.log(value);
                this.handleFormError(value);
              }}
              className="accountFormClass" //change
              name="nest-message"
              labelCol={{
              span: 20,
            }}
            >
              <div style={{ height: "100%" }}>
                <div
                  style={{
                    background: "#07163D",
                    padding: "15px",
                    height: "10%",
                  }}
                >
                  <h3 className="tab-title">{this.showTabTitle()}</h3>
                  <p className="tab-description">{this.showTabDesc()}</p>
                </div>
                <Tabs
                  className="accountTabs"
                  style={{ height: "90%" }}
                  activeKey={this.state.activeTab}
                  onChange={this.handleTabChange}
                >
                  <TabPane
                    tab={
                      <span
                        className={
                          this.state.tabErrors["1"] && "validation-failed"
                        }
                      >
                        <Button
                          type="text"
                          style={{
                            background:
                              this.state.activeTab === "1"
                                ? " rgba(255, 255, 255, 0.30)"
                                : "rgb(7, 22, 61)",
                            border: "none",
                            borderRadius: "0px",
                          }}
                        >
                          {this.context.translate(
                            "_SENSOR_MAPPING_"
                          )}
                        </Button>
                      </span>
                    }
                    key="1"
                  >
                    <Row style={{
                        overflowY: "scroll",
                        height: "92%",
                        paddingInlineStart: "20px",
                      }}>
                      <Col span={12} className="formColumnClass">
                        {(this.props.getUserData().isadmin === -1 ||
                          this.props.getUserData().isadmin === 3) && (
                            <Form.Item
                              name="companyId"
                              className="uploadCompany"
                              label={
                                <span>
                                  {this.context.translate("_ACCOUNT_")}{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </span>
                              }
                              required={false}
                              rules={[
                                {
                                  required: true,
                                  message: `${this.context.translate(
                                    "_ACCOUNT_"
                                  )} ${this.context.translate("_IS_REQUIRED_")}`,
                                },
                              ]}
                            >
                              <CompanyAutocomplete
                                onChange={(value) => {
                                  this.handleChange(value);
                                }}
                                style={{ width: "100%" }}
                              />
                            </Form.Item>
                          )}

                        <Form.Item
                          className="uploadCompany"
                          name="deviceId"
                          required={false}
                          rules={[
                            {
                              required: true,
                              message: `${this.context.translate(
                                "_DEVICE_",
                              )} ${this.context.translate(
                                "_IS_REQUIRED_",
                              )}`,
                            },
                          ]}
                          label={
                            <span>
                              {this.context.translate("_DEVICE_")}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                        >
                          <Select
                            onChange={(value) =>
                              this.handleDeviceFields(value)
                            }
                          >
                            {this.vehicleStore?.devices.map((val) => {
                              return (
                                <Option
                                  key={val.deviceId}
                                  value={val.deviceId}
                                >
                                  {val.deviceName}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>

                        <Form.Item
                          name="multiplier"
                          label={this.context.translate("_MULTIPLIER_")}
                          initialValue={1}
                        >
                          <InputNumber
                            min={0}
                            // step={0.1}
                            style={{ width: "100%" }}
                            controls={false}
                            onChange={(value) =>
                              this.setState({ multiplier: value })
                            }
                          />
                        </Form.Item>
                      </Col>

                      <Col span={12} className="formColumnClass">
              
                        <Form.Item
                          name="templateName"
                          className="uploadCompany"
                          label={
                            <span>
                              {this.context.translate("_TEMPLATE_NAME_")}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          required={false}
                          rules={[
                            {
                              required: true,
                              message: `${this.context.translate("_TEMPLATE_NAME_")} ${this.context.translate("_IS_REQUIRED_")}`,
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>

                        <Form.Item
                          name="sensorId"
                          className="uploadCompany"
                          label={this.context.translate("_SENSOR_ID_")}
                        >
                          <Select
                            showSearch
                            allowClear
                            optionFilterProp="children"
                            placeholder="Select Sensor"
                            value={this.state.selectedSensorId}
                            onChange={(value) =>
                              this.setState({ selectedSensorId: value })
                            }
                          >
                          {this.state.sensor_data.map((sensor) => {
                              const disabled = this.state.tableData.some(
                                (item) => item.sensorId === sensor.id
                              );

                              return (
                                <Select.Option
                                  key={sensor.id}
                                  value={sensor.id}
                                  disabled={disabled}
                                >
                                  {sensor.name} ({sensor.sensorId})
                                </Select.Option>
                              );
                            })}
                          </Select>
                        </Form.Item>

                        <Form.Item
                          name="sensorType"
                          className="uploadCompany"
                          label={this.context.translate("_SENSOR_TYPE_")}
                        >
                          <Select
                            showSearch
                            allowClear
                            optionFilterProp="children"
                            placeholder="Select Mapping"
                            value={this.state.selectedMappingId}
                            onChange={(value) =>
                              this.setState({ selectedMappingId: value })
                            }
                          >
                            {this.state.sensor_mapping.map((mapping) => {
                              const disabled = this.state.tableData.some(
                                (item) => item.mappingId === mapping.id
                              );

                              return (
                                <Select.Option
                                  key={mapping.id}
                                  value={mapping.id}
                                  disabled={disabled}
                                >
                                  {mapping.name}
                                </Select.Option>
                              );
                            })}
                          </Select>
                        </Form.Item>

                      </Col>

                      <Col span={24}>
                        <Row>
                          <Button
                            type="primary"
                            onClick={
                                this.state.editKey !== null && this.state.editKey !== undefined
                                    ? this.handleUpdateRecord
                                    : this.handleAddRecord
                            }
                            style={{ margin: "20px 0px 20px 0px" }}
                          >
                            {this.state.editKey !== null && this.state.editKey !== undefined ? this.context.translate("_UPDATE_SENSOR_") : this.context.translate("_ADD_SENSOR_")}
                          </Button>

                          {this.state.editKey !== null && this.state.editKey !== undefined && (
                            <Button
                              type="primary"
                              onClick={this.handleCancelEdit}
                              style={{ margin: "20px 0px 20px 9px" }}
                            >
                              {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
                            </Button>
                          )}

                        </Row>

                        <Table 
                          dataSource={this.state.tableData} 
                          pagination={false} 
                          bordered
                          onRow={(record) => ({
                              onClick: (e) => {
                                this.editRecord(record);
                              },
                          })}
                          rowClassName={(record) =>
                            record.key === this.state.editKey ? "editing-row" : ""
                          }
                        >

                          <Column
                            title={this.context.translate("_SENSOR_ID_")}
                            dataIndex="sensorName"
                            key="sensorName"
                          />

                          <Column
                            title={this.context.translate("_SENSOR_TYPE_")}
                            dataIndex="mappingName"
                            key="mappingName"
                          />

                          <Column
                            title={this.context.translate("_MULTIPLIER_")}
                            dataIndex="multiplier"
                            key="multiplier"
                          />

                          <Column
                            title="Operation"
                            key="action"
                            render={(text, record) => (
                              <div
                                className="actionColumn"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <Popconfirm
                                  title={this.context.translate("_DELETE_SENSOR_MAPPING_")}
                                  description={this.context.translate("_DELETE_SENSOR_MAPPING_DESC_")}
                                  okText="Yes"
                                  cancelText="No"
                                  onConfirm={() => {

                                    const updatedTable = this.state.tableData.filter(
                                        item => item.key !== record.key
                                    );

                                    this.setState({
                                        tableData: updatedTable,
                                    }, () => {

                                        this.checkSensorCalibration(updatedTable);

                                        if (this.state.editKey === record.key) {
                                            this.resetSensorForm();
                                        }

                                    });

                                  }}
                                >
                                  <DeleteFilled
                                    style={{ color: "red", cursor: "pointer" }}
                                  />
                                </Popconfirm>
                              </div>
                            )}
                          />
                        </Table>
                      </Col>
                    </Row>

                    <div className="formFooter">
                      
                      <Button
                        className="formsCancelButton"
                        onClick={() => {
                          this.closeSensorMappingForm();
                        }}
                      >
                        {this.context.translate(
                          "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                        )}
                      </Button>
                      
                      <Button
                        type="primary"
                        loading={this.state.loading}
                        className="formsSaveButton"
                        onClick={() => {
                          if (this.isLastTab()) {
                            this.formRef.current.submit();
                          } else {
                            this.handleNextClick();
                          }
                        }}
                      >
                        {this.context.translate(
                          this.isLastTab()
                            ? "_FLEET_DASHBORD_NEWPOI_SAVEBTN_"
                            : "_NEXT_"
                        )}
                      </Button>

                    </div>

                  </TabPane>

                  {
                    this.state.showFuelCalibration && (
                      <TabPane
                        tab={
                          <span
                            className={
                              this.state.tabErrors["2"] && "validation-failed"
                            }
                          >
                            <Button
                              style={{
                                background:
                                  this.state.activeTab === "2"
                                    ? " rgba(255, 255, 255, 0.30)"
                                    : "rgb(7, 22, 61)",
                                border: "none",
                                borderRadius: "0px",
                              }}
                              type=""
                            >
                              {this.context.translate(
                                "_FUEL_CALIBRATION_"
                              )}
                            </Button>
                          </span>
                        }
                        key="2"
                      >
                        <Row
                          style={{
                            overflowY: "scroll",
                            height: "90%",
                            paddingInlineStart: "20px",
                          }}
                        >
                          <Col span={12} className="formColumnClass">

                            <Form.Item
                              className="uploadCompany"
                              name="fuelCalibrationName"
                              label={
                                <span>
                                  {this.context.translate("_FUEL_CALIBRATION_NAME_")}{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </span>
                              }
                              required={false}
                              rules={[{ required: true, message: `${this.context.translate("_FUEL_CALIBRATION_NAME_")} ${this.context.translate("_IS_REQUIRED_")}` }]}
                            >
                              <Input />
                            </Form.Item>

                            <Form.Item
                              className="uploadCompany"
                              label={
                                <span>
                                  {this.context.translate("_FUEL_TANK_CAPACITY_")}{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </span>
                              }
                              required={false}
                              rules={[{ required: true, message: `${this.context.translate("_FUEL_TANK_CAPACITY_")} ${this.context.translate("_IS_REQUIRED_")}` }]}
                              name="fuelTankCapacity"
                            >
                              <Input
                                onChange={(e) =>
                                  this.validateFieldsValue(
                                    e.target.value,
                                    "fuelTankCapacity"
                                  )
                                }
                                onKeyUp={this.calculateVolumePerUnit}
                              />
                            </Form.Item>

                            <Form.Item
                              className="uploadCompany"
                              name="volumePerUnit"
                              label={
                                <span>
                                  {this.context.translate("_CHANGE_PER_VOLT_")}{" "}
                                </span>
                              }
                              required={false}
                            >
                              <Input
                                onChange={(e) =>
                                  this.validateFieldsValue(
                                    e.target.value,
                                    "volumePerUnit"
                                  )
                                }
                                value={this.state.volumePerUnit}
                              />
                            </Form.Item>

                          </Col>

                          <Col span={12} className="formColumnClass">

                            <Form.Item
                              className="uploadCompany"
                              name="maxVoltage"
                              label={
                                <span>
                                  {this.context.translate("_MAX_VOLTAGE_")}{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </span>
                              }
                              required={false}
                              dependencies={['minVoltage']}
                              validateFirst
                              rules={[
                                { required: true, message: `${this.context.translate("_MAX_VOLTAGE_")} ${this.context.translate("_IS_REQUIRED_")}` },
                                ({ getFieldValue }) => ({
                                  validator(_, max) {
                                    const min = getFieldValue("minVoltage");
                                    if (max === undefined || max === "") return Promise.resolve();
                                    if (min === undefined || min === "") return Promise.resolve(); 
                                    return parseFloat(max) >= parseFloat(min)
                                      ? Promise.resolve()
                                      : Promise.reject("Max voltage should be greater than Min voltage");
                                  },
                                }),
                              ]}
                            >
                              <Input
                                onChange={(e) =>
                                  this.validateFieldsValue(e.target.value, "maxVoltage")
                                }
                                onKeyUp={this.calculateVolumePerUnit}
                              />
                            </Form.Item>
          
                            <Form.Item
                              className="uploadCompany"
                              label={
                                <span>
                                  {this.context.translate("_MIN_VOLTAGE_")}{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </span>
                              }
                              required={false}
                              rules={[{ required: true, message: `${this.context.translate("_MIN_VOLTAGE_")} ${this.context.translate("_IS_REQUIRED_")}` }]}
                              name="minVoltage"
                            >
                              <Input
                                onChange={(e) =>
                                  this.validateFieldsValue(e.target.value, "minVoltage")
                                }
                                onKeyUp={this.calculateVolumePerUnit}
                              />
                            </Form.Item>
                          
                          </Col>

                          <Col span={24}>

                            <Button
                              type="primary"
                              onClick={this.handleAddFuelRecord}
                              style={{ margin: "20px 0px 20px 0px" }}
                            >
                              {this.context.translate("_ADD_RECORD_")}
                            </Button>
          
                            <Table
                              dataSource={this.state.fuelTableData}
                              style={{ marginInlineEnd: "10px" }}
                            >
                              <Column
                                width={20}
                                title={this.context.translate("_Id_")}
                                dataIndex="rId"
                                key="Id"
                                render={(text, record, index) => (
                                  <Input
                                    value={text !== undefined && text !== null ? text : 0}
                                    onChange={(e) =>
                                      this.handleInputChange(e, index, "rId")
                                    }
                                  />
                                )}
                              />

                              <Column
                                width={35}
                                title={this.context.translate("_FUEL_")}
                                dataIndex="fuel"
                                key="fuel"
                                render={(text, record, index) => (
                                  <Input
                                    value={text !== undefined && text !== null ? text : 0}
                                    onChange={(e) =>
                                      this.handleInputChange(e, index, "fuel")
                                    }
                                  />
                                )}
                              />
          
                              <Column
                                width={35}
                                title={this.context.translate("_VOLTAGE_")}
                                dataIndex="voltage"
                                key="voltage"
                                render={(text, record, index) => (
                                  <Input
                                    value={text}
                                    onChange={(e) =>
                                      this.handleInputChange(e, index, "voltage")
                                    }
                                  />
                                )}
                              />
          
                              <Column
                                width={10}
                                title={this.context.translate("_ACTION_")}
                                dataIndex=""
                                key=""
                                render={(text, record, index) => (
                                  <div>
                                    <Space>
                                      <Link
                                        onClick={async () => {
                                          await this.onDeleteRow(index);
                                        }}
                                      >
                                        <Tooltip
                                          title={this.context.translate(
                                            "_FLEET_DASHBORD_RULETRIGGER_DELETE_"
                                          )}
                                          color={config.tooltipColorDelete}
                                        >
                                          <Image
                                            src={require("../assets/images/NewDesign/Delete.png")}
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              this.setState({
                                                openDeleteModal: true,
                                                deleteData: record,
                                              })
                                            }
                                          ></Image>
                                        </Tooltip>
                                      </Link>
                                    </Space>
                                  </div>
                                )}
                              />
                            </Table>
                          </Col>

                        </Row>
                        
                        <div className="formFooter">
                          <Button
                            className="formsCancelButton"
                            style={{ marginInlineEnd: "10px" }}
                            onClick={() => {
                              this.closeSensorMappingForm();
                            }}
                          >
                            {this.context.translate(
                              "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                            )}
                          </Button>
                          <Button
                            className="formsCancelButton"
                            onClick={() => {
                              this.handleBackClick();
                            }}
                          >
                            {this.context.translate(
                              "_FLEET_USER_USERLIST_ASSIGNVEHICLE_BACKBTN_"
                            )}
                          </Button>
                          <Button
                            type="primary"
                            loading={this.state.loading}
                            className="formsSaveButton"
                            onClick={() => {
                              if (this.isLastTab()) {
                                this.formRef.current.submit();
                              } else {
                                this.handleNextClick();
                              }
                            }}
                          >
                            {this.context.translate(
                              this.isLastTab()
                                ? "_FLEET_DASHBORD_NEWPOI_SAVEBTN_"
                                : "_NEXT_"
                            )}
                          </Button>
                        </div>
                      </TabPane>
                    )
                  }

                  {
                    this.state.showWeightCalibration  && (
                      <TabPane
                        tab={
                          <span
                            className={
                              this.state.tabErrors["3"] && "validation-failed"
                            }
                          >
                            <Button
                              style={{
                                background:
                                  this.state.activeTab === "3"
                                    ? " rgba(9, 6, 6, 0.3)"
                                    : "rgb(7, 22, 61)",
                                border: "none",
                                borderRadius: "0px",
                              }}
                              type=""
                            >
                              {this.context.translate(
                                "_WEIGHT_CALIBRATION_"
                              )}
                            </Button>
                          </span>
                        }
                        key="3"
                      >
                        <Row
                          style={{
                            overflowY: "scroll",
                            height: "90%",
                            paddingInlineStart: "20px",
                          }}
                        >
                          <Col span={12} className="formColumnClass">

                            <Form.Item
                              className="uploadCompany"
                              name="weightCalibrationName"
                              label={
                                <span>
                                  {this.context.translate("_WEIGHT_CALIBRATION_NAME_")}{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </span>
                              }
                              required={false}
                              rules={[{ required: true, message: `${this.context.translate("_WEIGHT_CALIBRATION_NAME_")} ${this.context.translate("_IS_REQUIRED_")}` }]}
                            >
                              <Input />
                            </Form.Item>

                            <Form.Item
                              className="uploadCompany"
                              label={
                                <span>
                                  {this.context.translate("_MAX_WEIGHT_")}{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </span>
                              }
                              required={false}
                              rules={[{ required: true, message: `${this.context.translate("_MAX_WEIGHT_")} ${this.context.translate("_IS_REQUIRED_")}` }]}
                              name="maxWeight"
                            >
                              <Input
                                onChange={(e) =>
                                  this.validateFieldsValue(
                                    e.target.value,
                                    "maxWeight"
                                  )
                                }
                                onKeyUp={this.calculateWeightVolumePerUnit}
                              />
                            </Form.Item>

                            <Form.Item
                              className="uploadCompany"
                              name="volumePerUnitWeight"
                              label={
                                <span>
                                  {this.context.translate("_CHANGE_PER_VOLT_")}{" "}
                                </span>
                              }
                              required={false}
                            >
                              <Input
                                onChange={(e) =>
                                  this.validateFieldsValue(
                                    e.target.value,
                                    "volumePerUnitWeight"
                                  )
                                }
                                value={this.state.volumePerUnitWeight}
                              />
                            </Form.Item>

                          </Col>

                          <Col span={12} className="formColumnClass">

                            <Form.Item
                              className="uploadCompany"
                              name="maxVoltageWeight"
                              label={
                                <span>
                                  {this.context.translate("_MAX_VOLTAGE_")}{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </span>
                              }
                              required={false}
                              dependencies={['minVoltageWeight']}
                              validateFirst
                              rules={[
                                { required: true, message: `${this.context.translate("_MAX_VOLTAGE_")} ${this.context.translate("_IS_REQUIRED_")}` },
                                ({ getFieldValue }) => ({
                                  validator(_, max) {
                                    const min = getFieldValue("minVoltageWeight");
                                    if (max === undefined || max === "") return Promise.resolve();
                                    if (min === undefined || min === "") return Promise.resolve(); 
                                    return parseFloat(max) >= parseFloat(min)
                                      ? Promise.resolve()
                                      : Promise.reject("Max voltage should be greater than Min voltage");
                                  },
                                }),
                              ]}
                            >
                              <Input
                                onChange={(e) =>
                                  this.validateFieldsValue(e.target.value, "maxVoltageWeight")
                                }
                                onKeyUp={this.calculateWeightVolumePerUnit}
                              />
                            </Form.Item>
          
                            <Form.Item
                              className="uploadCompany"
                              label={
                                <span>
                                  {this.context.translate("_MIN_VOLTAGE_")}{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </span>
                              }
                              required={false}
                              rules={[{ required: true, message: `${this.context.translate("_MIN_VOLTAGE_")} ${this.context.translate("_IS_REQUIRED_")}` }]}
                              name="minVoltageWeight"
                            >
                              <Input
                                onChange={(e) =>
                                  this.validateFieldsValue(e.target.value, "minVoltageWeight")
                                }
                                onKeyUp={this.calculateWeightVolumePerUnit}
                              />
                            </Form.Item>
                          
                          </Col>

                          <Col span={24}>

                            <Button
                              type="primary"
                              onClick={this.handleAddWeightRecord}
                              style={{ margin: "20px 0px 20px 0px" }}
                            >
                              {this.context.translate("_ADD_RECORD_")}
                            </Button>
          
                            <Table
                              dataSource={this.state.weightTableData}
                              style={{ marginInlineEnd: "10px" }}
                            >
                              <Column
                                width={20}
                                title={this.context.translate("_Id_")}
                                dataIndex="weight_rId"
                                key="weight_Id"
                                render={(text, record, index) => (
                                  <Input
                                    value={text !== undefined && text !== null ? text : 0}
                                    onChange={(e) =>
                                      this.handleWeightInputChange(e, index, "weight_rId")
                                    }
                                  />
                                )}
                              />

                              <Column
                                width={35}
                                title={this.context.translate("_WEIGHT_")}
                                dataIndex="weight"
                                key="weight"
                                render={(text, record, index) => (
                                  <Input
                                    value={text !== undefined && text !== null ? text : 0}
                                    onChange={(e) =>
                                      this.handleWeightInputChange(e, index, "weight")
                                    }
                                  />
                                )}
                              />
          
                              <Column
                                width={35}
                                title={this.context.translate("_VOLTAGE_")}
                                dataIndex="weight_voltage"
                                key="weight_voltage"
                                render={(text, record, index) => (
                                  <Input
                                    value={text}
                                    onChange={(e) =>
                                      this.handleWeightInputChange(e, index, "weight_voltage")
                                    }
                                  />
                                )}
                              />
          
                              <Column
                                width={10}
                                title={this.context.translate("_ACTION_")}
                                dataIndex=""
                                key=""
                                render={(text, record, index) => (
                                  <div>
                                    <Space>
                                      <Link
                                        onClick={async () => {
                                          await this.onWeightDeleteRow(index);
                                        }}
                                      >
                                        <Tooltip
                                          title={this.context.translate(
                                            "_FLEET_DASHBORD_RULETRIGGER_DELETE_"
                                          )}
                                          color={config.tooltipColorDelete}
                                        >
                                          <Image
                                            src={require("../assets/images/NewDesign/Delete.png")}
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              this.setState({
                                                openDeleteModal: true,
                                                deleteData: record,
                                              })
                                            }
                                          ></Image>
                                        </Tooltip>
                                      </Link>
                                    </Space>
                                  </div>
                                )}
                              />
                            </Table>
                          </Col>

                        </Row>
                        
                        <div className="formFooter">
                          <Button
                            className="formsCancelButton"
                            style={{ marginInlineEnd: "10px" }}
                            onClick={() => {
                              this.closeSensorMappingForm();
                            }}
                          >
                            {this.context.translate(
                              "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                            )}
                          </Button>
                          <Button
                            className="formsCancelButton"
                            onClick={() => {
                              this.handleBackClick();
                            }}
                          >
                            {this.context.translate(
                              "_FLEET_USER_USERLIST_ASSIGNVEHICLE_BACKBTN_"
                            )}
                          </Button>
                          <Button
                            type="primary"
                            loading={this.state.loading}
                            className="formsSaveButton"
                            onClick={() => {
                              if (this.isLastTab()) {
                                this.formRef.current.submit();
                              } else {
                                this.handleNextClick();
                              }
                            }}
                          >
                            {this.context.translate(
                              this.isLastTab()
                                ? "_FLEET_DASHBORD_NEWPOI_SAVEBTN_"
                                : "_NEXT_"
                            )}
                          </Button>
                        </div>
                      </TabPane>
                    )
                  }
                  
                </Tabs>
              </div>
            </Form>
          </Spin>
        </div>
      </div>
    );

  }
}

SensorMappingAdd.contextType = StoreContext;
export default observer(withRouter(SensorMappingAdd));